import "./style.scss";

import { Collapse } from "@mui/material";
import SheetRecapBtn from "components/PartnerStatementsSettings/StatementFormContainer/StatementConfig/SheetRecap";
import AutocompleteFormComponent from "components/shared/FormComponent/AutocompleteFormComponent";
import { formatLocaleDateString } from "helpers/utils";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { IStatementTemplate } from "store/partnerStatementsStore";

import googleSheetLogo from "../../../assets/img/png/google-sheet-logo.png";
import type { TFormCreateBeneficiar } from "../types";

interface IPartnerStatementStep {
    indexStep: number;
    stepTitle: string;
    stepSubtitle: string;
    partnerStatements: IStatementTemplate[];
    mode: "edit-page" | "new";
}

const PartnerStatementStep = ({
    indexStep,
    stepTitle,
    stepSubtitle,
    partnerStatements,
    mode,
}: IPartnerStatementStep) => {
    const { control, watch } = useFormContext<TFormCreateBeneficiar>();
    const [t] = useTranslation();
    const activeStatements = partnerStatements.filter((statement) => statement.integrationId);
    const statementTemplate: IStatementTemplate | undefined | string = watch("customStatementTemplate");

    const onGoogleSheetNavigate = () => {
        window.open(
            `https://docs.google.com/spreadsheets/d/${(statementTemplate as IStatementTemplate)?.data
                .spreadsheetId}/edit#gid=${(statementTemplate as IStatementTemplate)?.data.sheetId}`,
            "_blank",
        );
    };

    const renderStatementsOptions = (props: any, option: any, data: any) => {
        return (
            <li {...props} key={`partner-statement-${option.id}`} className={`new-integration-options-list`}>
                <div className="integration-option-left">
                    <img src={googleSheetLogo} style={{ height: "20px", width: "20px", objectFit: "contain" }} />
                    <div className="integration-option-name">
                        <span>{option.name}</span>
                        <span>{`${t("PartnerStatements.EditedAt")} ${formatLocaleDateString({
                            date: option.modified ?? option.created,
                        })}`}</span>
                    </div>
                </div>
                <div className="integration-option-right"></div>
            </li>
        );
    };

    return (
        <div className="beneficiary-partner-statement-step">
            <h3 className="form-section-title">
                {indexStep + 1}. {stepTitle}
            </h3>
            <span className="form-section-description">{stepSubtitle}</span>
            <div className="form-fields">
                {!!activeStatements.length && (
                    <AutocompleteFormComponent
                        control={control}
                        label={t("PartnerStatements.SelectStatement")}
                        controlName="customStatementTemplate"
                        options={activeStatements}
                        renderOptionText={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) => option.name === value.name}
                        placeholder={t("PartnerStatements.NoSelected")}
                        renderOption={renderStatementsOptions}
                        defaultFilterOptions
                    />
                )}
                {!activeStatements.length && (
                    <>
                        <div className="select-statement-empty">
                            <h2 className="select-statement-empty-title">{t("PartnerStatements.NoStatementFound")}</h2>
                            <div className="select-statement-empty-text">
                                <span>{t("PartnerStatements.StatementParameter")}</span>
                                <span className="statement-settings-path">{t("PartnerStatements.ParameterPath")}</span>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <Collapse in={!!(statementTemplate as IStatementTemplate)?.id} timeout="auto">
                <div className="beneficiary-sheet-recap-btn">
                    <SheetRecapBtn
                        mode="edit"
                        onGoogleSheetNavigate={onGoogleSheetNavigate}
                        templateName={(statementTemplate as IStatementTemplate)?.name}
                    />
                </div>
            </Collapse>
        </div>
    );
};

export default PartnerStatementStep;
